/* eslint-disable */
import { useEffect, useState } from "react";
import { AuthContext } from "./AuthContext";
import { authProvider } from "./authProvider";

export const AuthCtxProvider = ({children})=>{
    const[data, setData] = useState({isAuthenticated: false, isAdministrator: false, isReportReader: false, isNocProf: false, accessToken: ""});
    useEffect(()=>{
        authProvider.getAccessToken().then(res=>{
            if (res.accessToken){
                var authState = {...data};
                authState.accessToken = res.accessToken;
                authProvider.getIdToken().then(res=>{
                    if (res.idToken) {
                        
                        authState.isAuthenticated = true;
                        if (res.idToken.claims && res.idToken.claims.roles) {
                            authState.isAdministrator = res.idToken.claims.roles.includes("Administrator");
                            authState.isReportReader = res.idToken.claims.roles.includes("Report.Read");
                            authState.isNocProf = res.idToken.claims.roles.includes("Administrator") ||
                                res.idToken.claims.roles.includes("NocUser") ||
                                res.idToken.claims.roles.includes("ProfSvcsUser");
                        }
                    }
                      setData(authState);
                });
            }

        });
        
    }, [])
    const {Provider} = AuthContext;
    return(
        <Provider value={data}>
            {children}
        </Provider>
    )
}